import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=9fd8690e&scoped=true"
import script from "./wxPay.vue?vue&type=script&lang=js"
export * from "./wxPay.vue?vue&type=script&lang=js"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=9fd8690e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd8690e",
  null
  
)

export default component.exports